import { memo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Title, TitleClose, AppBarSteled, TitleVersion } from './AppBar';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import GridComponent from '../grid/GridComponent.component';
import { Img } from '../img/Img';
import logo from "../../assets/logo/logoMinhaCenco.png";
import Toolbar from '@material-ui/core/Toolbar';
import { logout, getUser } from '../../core/auth/auth';
import { useLocation } from 'react-router-dom';
import accessToMenuOtions from '../sideBar/AccessToMenuOtions';
import { SideBarInterface } from '../sideBar/SideBarInterface';
import { useStore } from '../../context/Store';
import { LinkRouter } from '../../component/link/Link';
import { IFlag } from '../../container/store/utils/Flags';
import Modal from '../../container/patioManagement/components/modal/ModalHeader.component';
import useModal from '../../hooks/useModal';
import {useManagement} from '../../context/Management'

function MenuAppBar() {

  let location = useLocation().pathname.split('/')[1];
  const name: Array<string> = getUser().cn.split(" ");
  const title: SideBarInterface | undefined = accessToMenuOtions().find((el: SideBarInterface) => el.to === location);
  const { flag, store, nameStore, arrayFlags } = useStore();
 const [open, addModal] = useModal();
  const { valueCd } = useManagement();

  const closeModal = () => {
    addModal(!open);
  }

  const openModal = () => {
    addModal(!open);
  }

  useEffect(()=>{
    // console.log(arrayFlags)
    
    console.log(arrayFlags.find((el: IFlag) => {
      console.log(typeof el.id, "ID"); 
      console.log(typeof flag, "FLAG")
    }))
    // console.log(flag)
  },[])

  return (
    <AppBarSteled >
      <Toolbar>
        <LinkRouter to='/' ><Img  src={logo} width={34} height={34} /></LinkRouter>
        <div style={{ flexDirection: 'column', flexGrow: 1, alignItems: 'center', padding: '0px 0px 0px 10px', lineHeight: .8, marginTop: -7 }}>
          <Title>{`Bem-vindo, ${name[0]} ${name[1]}!`}</Title>
          {flag && <TitleVersion>{`${store ? store + ': ' + nameStore + ' -' : ''} ${arrayFlags.find((el: IFlag) => el.id === flag)?.flag} `} <Link to="/loja" style={{ fontSize: '12px', background: '#FF690A', padding: "2px 8px", color: "#FFF", borderRadius: 5, textDecoration: 'none', textShadow: '2px 1px 0px rgba(0,0,0,0.4)' }}>Trocar de loja</Link></TitleVersion>}

          {!flag && <Link to="/loja" style={{position: "relative", zIndex: "3", fontSize: '12px', background: '#FF690A', padding: "2px 8px", color: "#FFF", borderRadius: 5, textDecoration: 'none', textShadow: '2px 1px 0px rgba(0,0,0,0.4)' }}>Selecionar loja</Link>}
        </div>

        <Title style={{marginLeft: '50px'}}>
          {title?.text === 'Com. Corporativos' ? 
            'Comunicados Corporativos'
            : title?.text === 'Dados Comple.' ? 
              'Dados Complementares'
              : title?.text 
          }
        </Title>
        <GridComponent margin='23px 50px 0px 0px'>
          {location === 'gestao-de-patio' && valueCd ? <div style={{padding: '0px 0px 0px 0px', margin: '0px'}}><TitleVersion>CD - {valueCd}</TitleVersion><button style={{border:'none', borderRadius: '5px', background: '#FF690A', boxShadow: 'none', cursor:'pointer', color: '#fff', padding: '2px 8px', marginTop: '10px', marginLeft:'3px', textDecoration: 'none', textShadow: '2px 1px 0px rgba(0,0,0,0.4)', fontSize: '12px', fontFamily: 'Poppins, sans-serif'}} onClick={openModal}>Trocar de CD</button><Modal open={!!open} title={'Selecione o CD que deseja trabalhar'} onClickSubmit={closeModal}/></div> : location === 'gestao-de-patio' && !valueCd && <div style={{padding: '0px 0px 2px 0px', margin: '0px'}}><button style={{border:'none', borderRadius: '5px', background: '#FF690A', boxShadow: 'none', cursor:'pointer', color: '#fff', padding: '2px 8px', marginTop: '11px', textDecoration: 'none', textShadow: '2px 1px 0px rgba(0,0,0,0.4)', fontSize: '12px', fontFamily: 'Poppins, sans-serif'}} onClick={openModal}>Selecionar CD</button><Modal open={!!open} title={'Selecione o CD que deseja trabalhar'} onClickSubmit={closeModal}/></div>}
        </GridComponent>
        <LinkRouter to="/login" onClick={logout}>
          <GridComponent style={{position: "relative", zIndex:"3"}} direction='column'>
            <GridComponent>
              <TitleClose>Sair</TitleClose>

              <ExitToAppIcon fontSize="small" />
            </GridComponent>
            <TitleVersion> {`Versão ${process.env.REACT_APP_VERSION}${process.env.REACT_APP_API_TAREFAS?.includes('staging') ? 'h':''}`}</TitleVersion>
          </GridComponent>
        </LinkRouter>
      </Toolbar>
    </AppBarSteled >
  );
}

export default memo(MenuAppBar)
